var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99996 13.2712C3.54079 13.2712 0.729126 10.4595 0.729126 7.00033C0.729126 3.54116 3.54079 0.729492 6.99996 0.729492C10.4591 0.729492 13.2708 3.54116 13.2708 7.00033C13.2708 10.4595 10.4591 13.2712 6.99996 13.2712ZM6.99996 1.60449C4.02496 1.60449 1.60413 4.02533 1.60413 7.00033C1.60413 9.97533 4.02496 12.3962 6.99996 12.3962C9.97496 12.3962 12.3958 9.97533 12.3958 7.00033C12.3958 4.02533 9.97496 1.60449 6.99996 1.60449Z",
    fill: "#46AE31"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 9.47949C6.76083 9.47949 6.5625 9.28116 6.5625 9.04199V5.54199C6.5625 5.30283 6.76083 5.10449 7 5.10449C7.23917 5.10449 7.4375 5.30283 7.4375 5.54199V9.04199C7.4375 9.28116 7.23917 9.47949 7 9.47949Z",
    fill: "#46AE31"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75001 7.146C8.63917 7.146 8.52834 7.10517 8.44084 7.01767L7.00001 5.57684L5.55917 7.01767C5.39001 7.18684 5.11001 7.18684 4.94084 7.01767C4.77167 6.8485 4.77167 6.5685 4.94084 6.39934L6.69084 4.64934C6.86001 4.48017 7.14001 4.48017 7.30917 4.64934L9.05917 6.39934C9.22834 6.5685 9.22834 6.8485 9.05917 7.01767C8.97167 7.10517 8.86084 7.146 8.75001 7.146Z",
    fill: "#46AE31"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpIcon);
export default __webpack_public_path__ + "static/media/arrow-up-icon.2fb32aaee0931e22492ddbbec09ef600.svg";
export { ForwardRef as ReactComponent };